<template>
    <div class="container">
        <h1>Board "{{board['name']}}"</h1>
        <b-tabs position="is-centered" class="block" v-model="activeTab">
            <b-tab-item label="Info">
                <div class="container margin_top_1rem has-text-left">
                    <b-field label="Board name">
                        <b-input v-model="name" required placeholder="Enter name for board"></b-input>
                    </b-field>
                    <b-field label="Prio">
                        <b-numberinput type="is-light" v-model="prio" step="1" min="0"></b-numberinput>
                    </b-field>
                    <div class="buttons">
                        <b-button type="is-danger-outlined" @click="handleBack">Back</b-button>
                        <b-button type="is-success" :disabled="!changeRecorded()" @click="handleChange">Change
                        </b-button>
                    </div>
                </div>
            </b-tab-item>
            <b-tab-item :label="boardGroupsTitle">
                <div class="container margin_top_1rem has-text-left">
                    <div v-if="addFormVisible">
                        <b-field label="Choose object">
                            <b-select v-model="groupId">
                                <option :value="0">choose...</option>
                                <option
                                        v-for="group in availableGroups"
                                        :key="group.id"
                                        :value="group.id"
                                >{{group.name}}
                                </option>
                            </b-select>
                        </b-field>
                        <div class="buttons">
                            <b-button type="is-danger-outlined" @click="handleClickToggleAddForm">Abort</b-button>
                            <b-button type="is-success" @click="handleAddGroup" :disabled="!validAddGroupFields()">Add
                                group to board
                            </b-button>
                        </div>
                    </div>
                    <b-button type="is-info" v-else @click="handleClickToggleAddForm" class="is-small">Add Group
                    </b-button>
                </div>
                <div class="container has-text-left margin_top_1rem">
                    <b-table
                            v-if="tableData.length > 0"
                            :narrowed="true"
                            :striped="true"
                            :data="tableData"
                    >
                        <template slot-scope="props">
                            <b-table-column label="Group" field="object">
                                <router-link :to="{path: '/configure/group/' + props.row.group_id}">
                                    {{props.row.group_name}}
                                </router-link>
                            </b-table-column>
                            <b-table-column label="Order" field="prio" numeric>
                                <b-icon class="move" @click.native="handleMoveGroupUp(props.row.group_id)"
                                        type="is-primary"
                                        icon="arrow-up" v-if="props.row.allowMoveUp"></b-icon>
                                <b-icon class="move" @click.native="handleMoveGroupDown(props.row.group_id)"
                                        type="is-primary"
                                        icon="arrow-down" v-if="props.row.allowMoveDown"></b-icon>
                            </b-table-column>
                            <b-table-column field="delete" numeric>
                                <div @click="handleDeleteGroup(props.row.group_id)">
                                    <b-icon type="is-danger" icon="delete" style="cursor: pointer;"></b-icon>
                                </div>
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
            </b-tab-item>
            <b-tab-item label="Delete" v-if="board.allow_delete === 1">
                <div class="container margin_top_1rem">
                    <b-button type="is-danger" @click="handleDelete">Delete board</b-button>
                </div>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BTabs from "buefy/src/components/tabs/Tabs";
  import BTabItem from "buefy/src/components/tabs/TabItem";
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";
  import BNumberinput from "buefy/src/components/numberinput/Numberinput";
  import BSelect from "buefy/src/components/select/Select";
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    name: "screenconfigureboard",
    components: {
      BTableColumn,
      BTable,
      BSelect,
      BNumberinput,
      BButton,
      BInput,
      BField,
      BTabItem,
      BTabs
    },
    data() {
      return {
        activeTab: 0,
        name: '',
        prio: 0,
        initialName: '',
        initialPrio: 0,
        addFormVisible: false,
        groupId: 0
      };
    },
    computed: {
      ...mapGetters('objects', ['boardById', 'groups']),
      availableGroups() {
        const ret = [];
        Object.keys(this.groups).forEach(id => {
          ret.push(this.groups[id]);
        });
        return ret;
      },
      board() {
        return this.boardById(this.$route.params.id);
      },
      boardGroupsTitle() {
        return this.board.items.length > 0 ? 'Groups (' + this.board.items.length + ')' : 'Groups';
      },
      tableData() {
        const ret = [];
        let index = 0;
        this.board.items.forEach(item => {
          item['allowMoveUp'] = index > 0;
          item['allowMoveDown'] = index < this.board.items.length - 1;
          ret.push(item);
          index++;
        });
        return ret;
      }
    },
    methods: {
      ...mapActions('objects', ['modifyBoard', 'removeBoard', 'addGroupToBoard', 'removeGroupFromBoard', 'moveGroupInsideBoardUp', 'moveGroupInsideBoardDown']),
      handleClickToggleAddForm() {
        this.objectId = 0;
        this.addFormVisible = !this.addFormVisible;
      },
      changeRecorded() {
        return this.initialName !== this.name || this.initialPrio !== this.prio;
      },
      handleChange() {
        this.modifyBoard({
          id: this.board.id,
          name: this.name,
          prio: this.prio
        });
        this.resetFields();
      },
      handleDelete() {
        if (confirm('Are you sure ?')) {
          this.removeBoard(this.board.id);
          this.handleBack();
        }
      },
      handleBack() {
        this.$router.push('/configure/boards');
      },
      resetFields() {
        this.initialName = this.name;
        this.initialPrio = this.prio;
      },
      handleAddGroup() {
        this.addGroupToBoard({
          id: this.board.id,
          groupId: this.groupId
        });
        this.handleClickToggleAddForm();
      },
      validAddGroupFields() {
        return this.groupId > 0;
      },
      handleDeleteGroup(groupId) {
        if (confirm('Are you sure ?')) {
          this.removeGroupFromBoard({
            id: this.board.id,
            groupId: groupId
          });
        }
      },
      handleMoveGroupUp(groupId) {
        this.moveGroupInsideBoardUp({
          id: this.board.id,
          groupId: groupId
        });
      },
      handleMoveGroupDown(groupId) {
        this.moveGroupInsideBoardDown({
          id: this.board.id,
          groupId: groupId
        });
      }
    },
    mounted() {
      this.name = this.board ? this.board.name : '';
      this.prio = this.board ? parseInt(this.board.prio) : 0;
      this.resetFields();
    }
  }
</script>

<style scoped>
    h1 {
        font-size: 1.5rem;
        font-weight: bold;
        margin-top: 0.75rem;
        margin-bottom: 0.75rem;
    }

    .margin_top_1rem {
        margin-top: 1rem;
    }

    .margin_bottom_1rem {
        margin-bottom: 1rem;
    }

    .group_items {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .move {
        cursor: pointer;
    }
</style>